import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { usePlayerTrackInfo } from '@components/AudioPlayer/usePlayerTrackInfo';
import { Cover } from '@components/basics/Images/Cover';
import { useAudioController } from '@store/audio/AudioController';
import { SongInfoWrapper } from '../shared';

const RELEASE_COVER_SIZE = 40;

export const SongInfo = () => {
  const { activeTrackId } = useAudioController();
  const { releaseInfo } = usePlayerTrackInfo({
    trackId: activeTrackId,
    shouldFetch: true,
  });

  if (!releaseInfo) return null;

  const release = releaseInfo;

  const staticCoverImageUrl = release.staticCoverImage?.url;
  const coverImageUrl = release.coverImage.url ?? '';
  const artistName = release.artist?.name ?? 'Unnamed Artist';
  const songTitle = release.title ?? 'Unnamed Song';

  return (
    <Container>
      <Cover src={staticCoverImageUrl || coverImageUrl} alt={songTitle} size={RELEASE_COVER_SIZE} />
      <SongInfoWrapper>
        <SongTitle>{songTitle}</SongTitle>
        <ArtistName>{artistName}</ArtistName>
      </SongInfoWrapper>
    </Container>
  );
};

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  overflow: 'hidden',
});

const SongTitle = styled('h3', {
  title: 'XS',
  fontWeight: 500,
  color: '$white',
  whiteSpace: 'nowrap',
});

const ArtistName = styled('p', {
  base: 'XS',
  fontWeight: 400,
  color: '$white',
  whiteSpace: 'nowrap',
});
